/*
  After updating to Angular 14, we can make these pipes standalone pipes
  This way we can only import pipes we need in each module.
  NOTE: this will not be possible for pipes which uses other pipes (e.g from CommonModule)
  (internall common module uses function in pipes we can import those functions directly)
*/

import { NgModule } from '@angular/core';

import { PhxDistancePipe } from './phx-distance.pipe';
import { PhxCurrencyPipe } from './phx-currency.pipe';
import { PhxMetricUnitsPipe } from './phx-metric-unit.pipe'
import { PhxDateTimeFormatPipe } from './phx-date-time-format.pipe'
import { PhxRelativeTimePipe } from './phx-relative-time.pipe';
import { PhxTranslatePipe } from '../../translation/phx-translation.pipe'

const PIPES = [
  PhxDistancePipe,
  PhxCurrencyPipe,
  PhxDateTimeFormatPipe,
  PhxMetricUnitsPipe,
  PhxRelativeTimePipe,
]

@NgModule({
  declarations: PIPES,
  exports: PIPES,
  providers: [PhxTranslatePipe],
})
export class PhxPipesModule {}
